import React, { useState, Fragment } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Star from '@material-ui/icons/Star'
import StarBorder from '@material-ui/icons/StarBorder'
import IconButton from '@material-ui/core/IconButton'

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    margin: 'auto'
  }
})

const Rating = props => {
  const { classes, value } = props
  const ratings = [1, 2, 3, 4, 5]

  return (
    <div className={classes.root}>
      {ratings.map(item => (
        <Fragment color={'primary'}>{item <= value ? <Star /> : <StarBorder />}</Fragment>
      ))}
    </div>
  )
}

export default React.memo(withStyles(styles)(Rating))



// WEBPACK FOOTER //
// ./src/components/Rating.js